import * as yup from 'yup';

export const validationSchema = yup.object({
  failureReason: yup.string().required('Failure Reason is required')
});
